import { http } from '@/shared/lib/http';

import type { BranchListResponse } from './branches.types';

/** GET /api/v1/protheus/companies — lista empresas+filiais do tenant. */
export const branchesApi = {
  list: () => http.get('protheus/companies').json<BranchListResponse>(),
};
